import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { statusMembership, withLoading } from "../../../../../../utils";
import { updateMembership } from "../../../../../../utils";
import { listMemberships, deleteMembership } from "../../../../../../utils";

import {
  Grid, Button, CircularProgress,
  Menu, MenuItem, Container, useMediaQuery, Typography
} from "@material-ui/core";
import GeneralDialog from "../../../../../GeneralDialog/GeneralDialog";
import { sizing } from '@material-ui/system';
import { CEllipsisIcon } from "../../../../../Icons/Icons";
import moment from "moment";
import StatusTag from "./../../../../../TagComponents/StatusTag";
import Form from "../../../../../Form/Form";
import notEmpty from "../../../../../../FormValidation/notEmpty";
import CModal from "../../../../../Form/CModal";
import CDisplayArea from "../../../../../Form/CDisplayArea";
import LightTooltip from "../../../../../Form/LightTooltip";

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    width: "100%",
    paddingLeft: "50px",
    paddingRight: "50px",
    paddingTop: "15px",
  },
  mobilePadding: {
    width: "100%",
    paddingTop: "10px",
    paddingLeft: "10px",
    paddingRight: "10px"
  },
  topBlock: {
    paddingBottom: "15px",
  },
  recordRow: {
    paddingLeft: "5px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingRoght: "5px",
    width: "550px"
  },
  headingWrapper: {
    paddingBottom: "10px",
    boxShadow: "inset 0 -1px #e3e8ee",
  },
  rightElem: {
    float: "right",
  },
  rightElemPad: {
    float: "right",
    marginRight: "10px",
  },
  topHeading: {
    fontSize: "13px",
    color: "#1a1f36",
  },
  mobileTopHeadingTwo: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  topHeadingOne: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  topHeadingTwo: {
    fontSize: "28px",
    fontWeight: "light",
    color: "#1a1f36",
  },
  topHeadingThree: {
    backgroundColor: "#eb5757",
    opacity: "50%",
    paddingLeft: "15px",
    paddingRight: "15px",
    borderRadius: "2px",
    marginLeft: "10px",
    position: "absolute",
    marginTop: "6px",
    paddingTop: "2px",
    paddingBottom: "2px",
    fontSize: "14px",
  },
  topHeadingFour: {
    paddingLeft: "15px",
    paddingRight: "15px",
    borderRadius: "2px",
    marginLeft: "10px",
    position: "absolute",
    marginTop: "6px",
    paddingTop: "2px",
    paddingBottom: "2px",
    fontSize: "14px",
  },
  buttonBasic: {
    backgroundColor: "#ffffff",
    color: "#1a1f36",
    fontSize: "14px",
    boxShadow:
      " 0 0 0 1px rgb(42 47 69 / 10%), 0 2px 5px 0 rgb(42 47 69 / 10%), 0 1px 1.5px 0 rgb(0 0 0 / 7%), 0 1px 2px 0 rgb(0 0 0 / 8%), 0 0 0 0 transparent",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "3px",
    paddingBottom: "3px",
    textTransform: "none",
  },
  contentRow: {
    paddingTop: "15px",
    paddingBottom: "25px",
  },
  contentColumnFirst: {
    paddingRight: "20px",
    boxShadow: "inset -1px 0 #e3e8ee",
    display: "inline-block",
  },
  contentColumnMiddle: {
    boxShadow: "inset -1px 0 #e3e8ee",
    paddingLeft: "20px",
    paddingRight: "20px",
    display: "inline-block",
  },
  contentColumnLast: {
    paddingLeft: "20px",
    display: "inline-block",
  },
  labelText: {
    fontSize: "14px",
    color: "#697386",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueText: {
    fontSize: "14px",
    color: "#1a1f36",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueText2: {
    fontSize: "14px",
    color: "#3c4257",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextNeg: {
    fontSize: "14px",
    color: "#009211",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextBG: {
    fontSize: "16px",
    color: "#1a1f36",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextBold: {
    fontSize: "14px",
    color: "#1a1f36",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  valueTextPad: {
    fontSize: "14px",
    color: "#1a1f36",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft: "10px",
  },
  valueTextLink: {
    fontSize: "14px",
    color: "#3d5af1",
    cursor: "pointer",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  errorText: {
    fontSize: "14px",
    color: "#ff0000",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  blockLabel: {
    paddingTop: "10px",
    paddingBottom: "5px",
  },
  blockText: {
    paddingLeft: "10px",
  },
  subHeading: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  fieldRows: {
    paddingTop: "8px",
    paddingLeft: "10px",
  },
  fieldColumnOne: {
    width: "100px",
    display: "inline-block",
  },
  fieldColumnTwo: {
    display: "inline-block",
  },
  sdCustomCellOne: {
    border: "none",
    width: "10%",
    maxWidth: "200px",
    padding: "10px",
  },
  sdCustomCellTwo: {
    border: "none",
    width: "25%",
    maxWidth: "300px",
    padding: "10px",
  },
  sdCustomCellThree: {
    border: "none",
    width: "10%",
    maxWidth: "200px",
    padding: "10px",
  },
  sdCustomCellFour: {
    border: "none",
    padding: "10px",
  },
  headerPadding: {
    padding: "10px",
  },
  bottomSpacer: {
    height: "50px",
  },
  topMarginBlock: {
    marginTop: "10px",
  },
  loaderWrapper: {
    width: "100%",
    height: "calc(100vh - 64px)"
  },
  loaderMain: {
    position: "absolute",
    top: "50%",
    left: "50%"
  },
  formContainer: {
    border: '20px',
    backgroundColor: 'white',
    borderRadius: '4px',
    padding: "20px",
    maxWidth: "600px"
  }
}));

const Membership = () => {
  const classes = useStyles();
  const [_, updateState] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const small = useMediaQuery('(min-width: 750px)');
  const large = useMediaQuery('(min-width: 960px)');
  const customerMemDetails = useSelector((state) => {
    return state.customerMembershipDetails;
  });
  const businessId = useSelector((state) => {
    return state.buisnessDetails.businessId;
  });
  const [eOpen, setEOpen] = useState(false);
  const [aDOpen, setADOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const handleClose = () => {
    setEOpen(false);
    setADOpen(false);
  };
  const handleMenuClose = () => {
    setAnchorEl(false);
  };
  async function handleSubmit(event) {

    dispatch({
      type: 'UPDATE', payload: {
        loading: true
      }
    });
    let success = await updateMembership({
      businessId: businessId,
      membershipId: customerMemDetails.membershipId,
      name: event.name,
      description: event.description
    })
    dispatch({
      type: 'UPDATE', payload: {
        loading: false
      }
    });
    if (success) {
      setEOpen(false);
      updateState((_) => !_);
    }
  };
  async function handleClick(event) {
    let success = await withLoading(statusMembership, {
      businessId: businessId,
      membershipId: customerMemDetails.membershipId,
      isActive: customerMemDetails.isActive ? false : true,
    })
    if (success) {
      setADOpen(false);
      updateState((_) => !_);
    }
  }

  const { membershipIdURL } = useParams();

  useEffect(async () => {
    dispatch({
      type: "UPDATE",
      payload: {
        loading: true,
      },
    });

    let data = await listMemberships({
      businessId: businessId,
      membershipId: membershipIdURL,
    });

    dispatch({
      type: "UPDATE",
      payload: {
        loading: false,
        customerMembershipDetails: data ? data.membershipsDetails[0] : null,
      },
    });
  }, [_]);

  if (customerMemDetails && customerMemDetails.membershipId == membershipIdURL) {
    return (
      <Grid container className={large ? classes.mainWrapper : classes.mobilePadding}>
        <React.Fragment>
          <CModal open={eOpen} setOpen={setEOpen}
            children={
              <Container component="main" className={classes.formContainer}>
                <Form
                  action={handleSubmit}
                  postAction={null}
                  cancelEnabled
                  title="Edit Membership"
                  cancelAction={() => { setEOpen(false); }}
                  cancelText="Cancel"
                  submitText="Save"
                  inputFields={
                    [
                      {
                        type: "TextField",
                        validator: [notEmpty],
                        initialvalue: customerMemDetails.name,
                        label: "Name",
                        name: "name",
                      },
                      {
                        type: "TextArea",
                        initialvalue: customerMemDetails.description,
                        label: "Description",
                        name: "description",
                        resizeEnabled: false,
                        moreProps: {
                          rowsMin: 4,
                          rowsMax: 10
                        }
                      }
                    ]
                  }
                >
                </Form>
              </Container>
            }
          />
          <GeneralDialog
            open={aDOpen}
            close={handleClose}
            title={customerMemDetails.isActive ? "Deactivate Membership" : "Activate Membership"}
            text={customerMemDetails.isActive ? "Are you sure you want to deactivate this membership?" : "Are you sure you want to activate this membership?"}
            action={handleClick}
          />
          <GeneralDialog
            open={deleteOpen}
            close={() => { setDeleteOpen(false) }}
            title="Delete Membership"
            text="Are you sure you want to delete this membership permanently?"
            action={async () => {
              let success = withLoading(deleteMembership, {
                businessId: businessId,
                membershipId: customerMemDetails.membershipId
              })
              if (success && success.error == false) {
                history.replace(`/dashboard/${businessId}/Memberships`);
              }

            }}
          />
        </React.Fragment>
        <Grid container item xs={12} direction="row">
          <Grid item xs={6}>
            <div className={classes.topBlock}>
              <span className={classes.topHeading}>MEMBERSHIP</span>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.topBlock}>
              <span className={classes.rightElem}>
                <Button onClick={(event) => { setAnchorEl(event.currentTarget); }} className={classes.buttonBasic}><CEllipsisIcon /></Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={() => { setEOpen(true); handleMenuClose(); }}>Edit</MenuItem>
                  <MenuItem onClick={() => { setADOpen(true); handleMenuClose(); }}>{customerMemDetails.isActive ? "Deactivate" : "Activate"}</MenuItem>
                  {!customerMemDetails.isActive ?
                    <MenuItem onClick={() => { setDeleteOpen(true); setAnchorEl(false) }}>
                      <Typography >
                        Delete Membership
                      </Typography>
                    </MenuItem> : null}
                </Menu>
              </span>
            </div>
          </Grid>
        </Grid>
        <Grid container className={classes.headerPadding} item xs={12} direction="row">
          <Grid item style={(small ? { marginLeft: -10, maxWidth: "50%" } : { marginLeft: -10, width: "100%" })}>
            <div>
              <LightTooltip title={customerMemDetails.name} arrow>
                <Typography className={small ? classes.topHeadingOne : classes.mobileTopHeadingTwo} noWrap style={{ width: `calc(100%)` }}>
                  {customerMemDetails.name}
                </Typography>
              </LightTooltip>
            </div>
          </Grid>
          <Grid item style={small ? { paddingLeft: "20px" } : { paddingLeft: "10px" }}>
            <div className={small ? classes.headerPadding : null}>
              <span className={small ? classes.topHeadingFour : null}>
                <StatusTag wrapperName={customerMemDetails.isActive ? "greenWrapper" : "redWrapper"} value={customerMemDetails.isActive ? "Active" : "Inactive"} />
              </span>
            </div>
          </Grid>

        </Grid>
        <Grid item xs={12}>
          <div className={classes.headingWrapper}>
            <span className={classes.labelText}>Description</span>
          </div>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "10px" }}>
          <span className={classes.valueText}>
            <CDisplayArea
              value={customerMemDetails.description ? customerMemDetails.description : null}
              initialMaxHeight={"calc(100vh - 360px)"}
            />
          </span>{" "}
        </Grid>
        <Grid item xs={12}>
          <div className={classes.bottomSpacer}></div>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container className={classes.mainWrapper}>
        <Grid item xs={12}>
          <div className={classes.loaderWrapper}>
            <CircularProgress className={classes.loaderMain} />
          </div>
        </Grid>
      </Grid>
    );
  }
};

export default Membership;
